export default __webpack_public_path__ + "static/media/app-inicio.6bfa664c.jpeg";